import { render } from "./Inventory.vue?vue&type=template&id=47fef3c7&bindings={}"
import script from "./Inventory.vue?vue&type=script&lang=js"
export * from "./Inventory.vue?vue&type=script&lang=js"

import "./Inventory.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script